import classNames from "classnames/bind";
import { Link, useNavigate, useParams } from "react-router-dom";
import { BackIcon } from "../../../../components/Icons/Icons";
import ServicesPack from "../ListServices/ServicePack";
import styles from './SubscribeService.module.css';
import { useEffect, useState } from "react";
import Loading from "../../../../components/Loading";
import SelectBox from "../../../../components/SelectBox";
import SelectBoxItem from "../../../../components/SelectBox/SelectBoxItem";
import InfoUserItem from "../../../InfoUser/ShowInfoUser/InfoUserItem";
import Button from "../../../../components/Button/Button";
import axiosClient from "../../../../services/axiosClient";
import { format, getDateEnd, validatorDataIsNumber } from "../../../../utils";
import ActImage from "../../../../assets/images/detect-action.png";
import FaceImage from '../../../../assets/images/detect-face.png';
import HumanImage from '../../../../assets/images/detect-human.png';
import Toast from "../../../../components/Toast";
import { Alert, Col, Row, Switch } from "../../../../components";
import { company } from "../../../../services/api/comaniesService";
import { recordApi } from "../../../../services/api/RecordApi";
const cx = classNames.bind(styles);

function SubscribeService() {
    const [dataPackService, setDataPackService] = useState()
    const [listPackService, setListPackService] = useState()
    const [time, setTime] = useState(0)
    const [codePack, setCodePack] = useState()
    const [totalPrice, setTotalPrice] = useState(0)
    const [gift, setGift] = useState(0)
    const [isMaximum, setIsMaximum] = useState(false)
    const [companyName, setCompanyName] = useState('')
    const [resolution, setResolution] = useState('') 
    const [timeSaveRecord, setTimeSaveRecord] = useState(14) 
    const [promotion, setPromotion] = useState('')
    const [autoRenew, setAutoReNew] = useState(true)
    const navigate = useNavigate()
    const date = new Date()
    const params = useParams()
    useEffect(() => {
        const getData = async () => {
            const res = await axiosClient.get(`/service/get-list-services/?service_code=${params.id}`)
            const data = res.map((item) => {
                if (item?.SUBJECT_NAME === 'Phát hiện chuyển động') {
                    return {
                        ...item,
                        IMAGE: ActImage
                    }
                }
                if (item?.SUBJECT_NAME === 'Nhận diện khuôn mặt') {
                    return {
                        ...item,
                        IMAGE: FaceImage
                    }
                }
                if (item?.SUBJECT_NAME === 'Phát hiện người') {
                    return {
                        ...item,
                        IMAGE: HumanImage
                    }
                } else {
                    return item
                }
            })
            setDataPackService(data)
        }
        getData()
    }, [params.id])

    const getCompany = async (companyCode) => {
        try {
            const param = {
                company_code: companyCode
            }
            const companyInfo = await company.get(param);
            setCompanyName(companyInfo?.data[0]?.NAME || '');
        } catch (error) {
            Toast.open('Lấy thông tin công ty không thành công', 'danger')
            console.error("getCompany", error);
        }
    }

    const getRecordQuality = async (codeCam) => {
        try {
          let params = {
            camera_code: codeCam,
          };
          const recordRate = await recordApi.getRecordQualityConfig(params);
          setResolution(recordRate?.quality || '')
        } catch (error) {
            Toast.open('Lấy thông tin chất lượng hình ảnh không thành công', 'danger')
          console.error("Can't get record rate");
        }
      };

    useEffect(() => {
        const companyCode = sessionStorage.getItem('company_code')
        if (companyCode !== 'DEFAULT') {
            getCompany(companyCode);
        } else {
            setCompanyName('DEFAULT')
        }
        getRecordQuality()
    }, [])
    const userHandlePayService = () => {
        const codeService = dataPackService[0].CODE;
        // const totalPrice = countCamera * dataPackService[0].COST;
        // if (codePack && countCamera > 0) {
            const code = codeService;
            const timeStart = format(date);
            const timeEnd = getDateEnd(date, time);
            const servicePackCode = codePack;
            const price = totalPrice;
            const ticket = JSON.stringify({
                service_code: code,
                time_use_s: timeStart,
                time_use_e: timeEnd,
                service_pack_code: servicePackCode,
                price: price,
            })
            sessionStorage.setItem('packService', ticket)
            navigate('/admin/service/pay-service')
        // } else if (countCamera > 0) {
        //     Toast.open('Vui lòng chọ chọn gói dịch vụ!', 'danger')
        // } else {
        //     Toast.open('Vui lòng chọn số camera áp dụng!', 'danger')
        // }

    }
    useEffect(() => {
        const getListPack = async () => {
            const res = await axiosClient.get('/servicePack/get-list-servicePack/')
            setListPackService(res);
        }
        getListPack()
    }, [])

    const handleChoseTimePack = (e) => {
        if (listPackService) {
            listPackService.forEach(item => {
                if (item.CODE === e) {
                    setTime(item.TIME_USE)
                    setCodePack(e)
                    setGift(0)
                }
            });
        }
    }

    // const handleChangeCountCamera = (value) => {
    //     setCountCamera(value)
    //     const maximumCamera = 1000;
    //     if (value < maximumCamera) {
    //         const checkNumber = validatorDataIsNumber(value)
    //         if (checkNumber && dataPackService && dataPackService.length > 0 && value !== '') {
    //             let price = value * dataPackService[0].COST
    //             setTotalPrice(price)
    //         } else {
    //             setTotalPrice(0)
    //         }
    //     } else {
    //         setIsMaximum(true)
    //     }
    // }

    const hideDangerMaximum = () => {
        setIsMaximum(false)
    }

    const handleChangeTimeSaveRecord = (data) => {
        setTimeSaveRecord(data)
    }

    const handleChangePromotion = (data) => {
        setPromotion(data)
    }

    const handleChangeAutoReNew = (value) => {
        setAutoReNew(value)
    }
    return (
        <>
            <div id="__notification"></div>
            {isMaximum && <Alert content={'Số camera bạn nhập quá lớn vui lòng liên hệ quản trị viên!'} onClose={hideDangerMaximum} onOk={hideDangerMaximum} />}
            <div className={cx('header')}>
                <Link className={cx('button-back')} to={'/admin/service'}>
                    <BackIcon />
                    <h1 className={cx('user-name')}>
                        Xác nhận đăng ký
                    </h1>
                </Link>
            </div>
            <div className={cx('container')}>
                <Row gap={[8, 8]}>
                    <Col span={3}>
                        <div className={cx('service')}>
                            {dataPackService && dataPackService.length > 0 ?
                                <ServicesPack
                                    name={dataPackService[0].SUBJECT_NAME}
                                    price={dataPackService[0].COST / 1000}
                                    event={dataPackService[0].SUBJECT_NAME}
                                    custom={dataPackService[0].custom}
                                    status={dataPackService[0].STATUS}
                                    image={dataPackService[0].IMAGE}
                                /> :
                                <Loading />
                            }
                        </div>
                    </Col>
                    <Col span={5}>
                        <div className={cx('pack-info')}>
                            <InfoUserItem
                                full
                                label={'Công ty'}
                                disabled
                                value={companyName}
                                placeholder={'Nhập'}
                                type={'text'}
                            />
                            <InfoUserItem
                                full
                                label={'Tên dịch vụ'}
                                disabled
                                value={ dataPackService ? dataPackService[0]?.SUBJECT_NAME : ''}
                                placeholder={'Nhập'}
                                type={'text'}
                            />
                            <InfoUserItem
                                full
                                label={'Chất lượng hình ảnh'}
                                disabled
                                value={resolution}
                                placeholder={'Nhập'}
                                type={'text'}
                            />
                            <InfoUserItem
                                full
                                label={'Thời gian lưu trữ (ngày)'}
                                value={timeSaveRecord}
                                min={1}
                                max={20}
                                placeholder={'Nhập'}
                                type={'number'}
                                onChange={handleChangeTimeSaveRecord}
                            />
                            <InfoUserItem
                                full
                                label={'Thời gian bắt đầu'}
                                value={'20/02/2024'}
                                placeholder={'Nhập'}
                                disabled
                                type={'date'}
                            />
                            <InfoUserItem
                                full
                                label={'Mã khuyến mãi'}
                                value={promotion}
                                placeholder={'Nhập'}
                                type={'text'}
                                onChange={handleChangePromotion}
                            />
                            <SelectBox title={'Phương thức thanh toán'} values={'Chuyển khoản ngân hàng'} style={{ paddingTop: 4 }}>
                                <SelectBoxItem label={'Chuyển khoản ngân hàng'} value={'0'} />
                            </SelectBox>
                            <SelectBox title={'Gói đăng ký'} onChange={handleChoseTimePack}>
                                {listPackService && listPackService.map((item) => {
                                    return (
                                        <SelectBoxItem label={item?.TYPE} value={item?.CODE} key={item?.CODE} />
                                    )
                                })}
                            </SelectBox>
                            <div className={cx('auto-renew')}>
                                <Switch type="small" onChange={handleChangeAutoReNew} value={autoRenew}/>
                                <label>Tự động gia hạn</label>
                            </div>
                        </div>
                    </Col>
                    <Col span={4}>
                        <div className={cx('total-credit')}>
                            <p className={cx('header-info')}>Tổng tiền</p>
                            <ul className={cx('ticket')}>
                                <li className={cx('ticket-info')}>
                                    <p className={cx('label-info')}>Tạm tính</p>
                                    <p className={cx('price-info')}>{totalPrice.toLocaleString("de-DE", { minimumFractionDigits: 0 })} đ</p>
                                </li>
                                <li className={cx('ticket-info')}>
                                    <p className={cx('label-info')}>Phí</p>
                                    <p className={cx('price-info')}>0 đ</p>
                                </li>
                                <li className={cx('ticket-info')}>
                                    <p className={cx('label-info')}>Khuyến mãi</p>
                                    <p className={cx('price-info')}>{gift.toLocaleString("de-DE", { minimumFractionDigits: 0 })} đ</p>
                                </li>
                            </ul>
                            <div className={cx('total-money')}>
                                <p className={cx('label-info')}>Tạm tính</p>
                                <p className={cx('total-price')}>{(totalPrice - gift).toLocaleString("de-DE", { minimumFractionDigits: 0 })} đ</p>
                            </div>
                            <div className={cx('submit-button')}>
                                <Button title={'Thanh toán'} onClick={userHandlePayService} className={cx(false ? 'disable' : '')} />
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    )
}

export default SubscribeService;